import {
  DATA_SOURCE_KEY_MAPPING,
  getDataSourceByKeys,
  SMART_PAGE_DEFAULT_VALUES,
  truncateString,
} from '@bingads-webui-campaign-react/smart-component-util';
import { proxyReadHeaderComponentConfig } from '@bingads-webui-campaign-react/smart-component-header';

import { dataProperties, headlineMaxCount } from './data-config';

export const proxyReadIntroductionComponentConfig = (componentConfig, siteConfig, i18n) => {
  const {
    [dataProperties.headline]: headline,
    [dataProperties.description]: description,
  } = componentConfig;

  const [
    businessCategories,
    businessDescription,
  ] = getDataSourceByKeys(siteConfig, [
    DATA_SOURCE_KEY_MAPPING.BusinessCategories,
    DATA_SOURCE_KEY_MAPPING.BusinessDescription,
  ]);

  const {
    businessName,
    defaultBusinessName,
    logo,
  } = proxyReadHeaderComponentConfig(componentConfig, siteConfig, i18n);

  const descriptionFromCategory = businessCategories && businessCategories.join(', ');

  return {
    headline,
    defaultHeadline: truncateString(businessName || defaultBusinessName, headlineMaxCount),
    description,
    defaultDescription: businessDescription || descriptionFromCategory ||
      i18n.getString(SMART_PAGE_DEFAULT_VALUES.DESCRIPTION),
    logo: logo || {},
  };
};
